// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interlineado[data-v-418cbb03]{line-height:1.2em}", ""]);
// Exports
module.exports = exports;
